import {
  normalizeAnalyticsEventName,
  normalizeAnalyticsEventParams,
} from '@/analytics/analytics-payload';
import {
  dispatchClarityEvent,
  startClarityBootstrap,
} from '@/analytics/clarity-browser';
import { dispatchGoogleAnalyticsEvent } from '@/analytics/google-analytics-browser';

type AnalyticsEventProperties = Record<string, unknown>;

function isBrowser() {
  return typeof window !== 'undefined';
}

function dispatchAnalyticsEvent(
  event: string,
  properties?: AnalyticsEventProperties
) {
  const normalizedEvent = normalizeAnalyticsEventName(event);
  const normalizedProperties = normalizeAnalyticsEventParams(properties, {
    maxParameters: 25,
  });

  dispatchGoogleAnalyticsEvent(normalizedEvent, normalizedProperties);
  dispatchClarityEvent(normalizedEvent);
}

export function captureAnalyticsEvent(
  event: string,
  properties?: AnalyticsEventProperties
) {
  if (!isBrowser()) {
    return;
  }

  startClarityBootstrap();
  dispatchAnalyticsEvent(event, properties);
}
